export const evenement = {
  listes: {
    title: 'Liste des événements',
    fiche: {
      title_fiche: "Fiche de l'évènement {{label}} n° {{number}}",
      title_cache: 'Virements de Cash-Pooling',
      title_compte: 'Intérêts des comptes courants',
      title_echeance: 'Paiement écheance',
      title_placement: 'Placement',
      imprime: 'Imprimer',
      envoi_mail: 'Envoyer par email',
      msg_confirm_mail: "Voulez-vous envoyer l'état par email ",
      champs: {
        type: ' Type',
        sub_type: 'Sous-type',
        etat: 'Etat',
      },
      modal: {
        title: 'Modification du calcul',
        amount: 'Montant',
        date: 'Date',
        batch_warning:
          'IMPORTANT : Le flux est présent dans le parapheur, veuillez le supprimer du lot.',
      },
      culumns: {
        name: 'Nom',
        emetter: 'Emetteur',
        benefic: 'Bénéficiaire',
        amount: 'Montant',
        devise: 'Devise',
        etat: 'Etat',
        date: 'Date',
      },
      generate_entries: 'Génération écritures',
      validate_entries: 'Valider',
      archivage: 'Réaliser',
    },
  },
  liste: {
    table: {
      title: 'Liste des taux de référence personnalisés',
      columns: {
        event_num: 'Num Evnt',
        type: 'Type',
        sub_type: 'Sous-type',
        libelle: 'Libellé',
        nb: 'Nb',
        amount: 'Montant',
        currency: 'Devise',
        state: 'Etat',
        date: 'Date de création',
        login: 'Login',
      },
    },
    fiche: {
      edit_title: 'Fiche du taux de référence personnalisé {{name}}',
      new_title: "Création d'un nouveau taux de référence personnalisé",
      champ_titles: {},
    },
  },
}

